import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStuds = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 126,
	height: 18,
	viewBox: "0 0 126 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M126 18V17.3928H117.812V9.92836C117.812 8.62391 116.799 7.60933 115.497 7.60933H92.9275C91.6254 7.60933 90.6128 8.62391 90.6128 9.92836V17.3928H74.4093V9.92836C74.4093 8.62391 73.3965 7.60933 72.0945 7.60933H49.5254C48.2233 7.60933 47.2106 8.62391 47.2106 9.92836V17.3928H39.1812V0H0V18H126Z",
		fill: "currentColor"
	})
});
export default SvgStuds;
